<template>
    <div class="content">
        <el-form
            :label-position="labelPosition"
            label-width="80px"
            :model="formLabelAlign"
            ref="formLabelAlign"
            :rules="formLabelRules"
        >
            <el-form-item label="头像" prop="head">
                <div @click="uploading">
                    <img
                        :src="formLabelAlign.head"
                        alt=""
                        style="width: 80px; height: 80px; border-radius: 50%"
                    />
                    <input
                        type="file"
                        @change="handleFileChange"
                        ref="fileInput"
                        style="display: none"
                    />
                </div>
            </el-form-item>
            <el-form-item label="昵称" prop="nickName">
                <el-input v-model="formLabelAlign.nickName"></el-input>
            </el-form-item>

            <el-button
                :loading="loading"
                type="primary"
                style="
                    width: 100%;
                    margin-top: 35px;
                    background: #0195ff;
                    box-shadow: 0 2px 9px 0 #0195ff33;
                    border-radius: 8px;
                "
                @click.native.prevent="submit"
                >提交</el-button
            >
        </el-form>
    </div>
</template>

<script>
import { updateUser, userInfo, upload } from '@/api/index'
export default {
    data() {
        return {
            labelPosition: 'top',
            formLabelAlign: {
                nickName: '',

                head: ''
            },
            formLabelRules: {
                nickName: [
                    {
                        required: true,
                        trigger: 'blur',
                        message: '请输入昵称'
                    }
                ],
                head: [
                    {
                        required: true,
                        trigger: 'blur',
                        message: '请上传头像'
                    }
                ]
            }
        }
    },
    created() {
        this.getUser()
    },
    methods: {
        // 上传
        uploading() {
            this.$refs['fileInput'].click()
        },
        handleFileChange(event) {
            console.log(event)
            this.selectedFile = event.target.files[0]
            if (!this.selectedFile) {
                return
            }
            const formData = new FormData()
            formData.append('file', this.selectedFile)
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            upload(formData)
                .then((res) => {
                    loading.close()
                    console.log(res)
                    this.formLabelAlign.head = res.url
                })
                .catch((error) => {
                    console.error('Error uploading image:', error)
                    // 处理上传失败后的逻辑
                })
        },
        getUser() {
            userInfo().then((res) => {
                console.log(res)
                if (res.code == 0) {
                    this.formLabelAlign = {
                        nickName: res.data.nickName,

                        head: res.data.head
                    }
                    localStorage.setItem('userInfo', JSON.stringify(res.data))
                }
            })
        },
        submit() {
            this.$refs.formLabelAlign.validate((valid) => {
                if (valid) {
                    this.loading = true
                    updateUser(this.formLabelAlign).then((response) => {
                        this.loading = false
                        console.log(response)
                        if (response.code == 0) {
                            this.$message({
                                message: '提交成功',
                                type: 'success'
                            })
                        }
                    })
                    location.reload()
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    padding: 30px;
    box-sizing: border-box;
}
</style>